/* Copyright(c) 2020 APSS Media Pvt. Ltd.
 *  All Rights Reserved
 */
/*@author Chaitanya Shinde
 *@fileName : permittedAssets.js
 *Desc:Task- 5566
 *@Date of creation: 30/01/2025
 */

import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { logoutUser } from "../login/authentication";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import PublisherNavigation from "../layouts/publisherNavPage";
import Footer from "../layouts/footer";
import "antd/dist/antd.css";
import { fetch_custom as fetch } from "../../configration/fetch_default_headers";
import { FaArrowAltCircleLeft } from "react-icons/fa"; //import Back Button
import { Tooltip, Icon, Table } from "antd";
import { css } from "emotion";
import "./permittedAssets.css";
import styled from "styled-components"; //Anshul-5685: 
const Swal = require("sweetalert2");
const xlsx = require("xlsx"); //use for download the excel file

const tableCSS = css({
  backgroundColor: "white",
  fontFamily: "sans-serif",
  borderStyle: "bold",
  "& thead  > tr": {
    backgroundImage: "linear-gradient(to right,#28166f,#007cc3) !important",
    color: "white",
    fontSize: "12px !important",
    fontWeight: "500",
    position: "sticky", // Keeps the header fixed
    top: 0,
    zIndex: 2,
  },
  "& thead > tr >th": {
    textAlign: "center !important",
    color: "white",
  },
  "& .ant-table-body": {
    maxHeight: "300px !important", // Enables vertical scrolling
    //overflowY: "auto !important",
  },
});

class PermittedAssets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //declaration of parameters
      error: {},
      loading: "",
      tableFlag: "false",
      loader: "",
      fileName: "",
      tableState: { size: "small" },
      permittedAsset: [],
      multitouchAssetConfigurationarray: [], //Chaitanya-5617-initialized multitouchAssetConfigurationarray for storing multitouch Asset Configuration
      multitouchAssetConfigurationCheck: "No", //Chaitanya-5617-initialized multitouchAssetConfigurationCheck No
    }; //end of this.state

    this.refreshPage = this.refreshPage.bind(this);
    this.backButtonFunction = this.backButtonFunction.bind(this);
    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleApplyChanges = this.handleApplyChanges.bind(this);
  }

  refreshPage(e) {
    e.preventDefault();
    window.location.reload();
  }

  backButtonFunction(e) {
    e.preventDefault();
    this.props.history.push("/publisherCampaignList");
  }

  /**
   * @author : Chaitanya Shinde-5566
   * @description : function for search asset by Id and Name
   */

  handleChangeSearch(e) {
    e.preventDefault();
    let filterData = e.target.value.toLowerCase();
    //rutuja 5617 when ther is multitouch asset config thrn search will be done on asset touch 1 and asset touch 2
    if(this.state.multitouchAssetConfigurationCheck == "Yes"){
      let newList = this.state.originalMultitouchAssetConfigurationarray
      .map((item) => {
        let selectedItem = this.state.multitouchAssetConfigurationarray.find(
          (p) => p.configID === item.configID
        );
        return selectedItem ? { ...item, allowFlag: selectedItem.allowFlag } : item;
      })
      .filter((item) => {
        let firstTouch = item.firstTouch?.toLowerCase() || "";
        let secondTouch = item.secondTouch?.toLowerCase() || "";
        let searchTerm = filterData.toLowerCase();
  
        return firstTouch.includes(searchTerm) || secondTouch.includes(searchTerm);

        
      });


    // Update state with filtered data
    this.setState({
      multitouchAssetConfigurationarray: newList,
      tableSearchText: filterData,
    });
    }
    else{
       //Nilesh-5612- Preserve checkbox state when filtering
      let newList = this.state.originalPermittedAsset
      .map((item) => {
        let selectedItem = this.state.permittedAsset.find(
          (p) => p.supportDocID === item.supportDocID
        );
        return selectedItem ? { ...item, allowFlag: selectedItem.allowFlag } : item;
      })
      .filter((item) => {
        let searchString = `${item.supportDocID} ${item.suppDocName}`.toLowerCase();
        return searchString.includes(filterData);
      });
    // Update state with filtered data
    this.setState({
      permittedAsset: newList,
      tableSearchText: filterData,
    });
    }
    }

  /**
   * @author : Chaitanya Shinde-5566
   * @description : function for check or uncheck assets
   */
  handleCheckboxChange = (e, record) => {
    const isChecked = e.target.checked;

    this.setState((prevState) => {
        //Nilesh-5612- Update both permittedAsset and originalPermittedAsset
        //Rutuja 5617 added below code when multitouch config is yes
        if(this.state.multitouchAssetConfigurationCheck == "Yes"){
              //Chaitanya-5617-Preserve checkbox state for `multitouchAssetConfigurationarray` using `configID`
        const updatedMultiTouchAssets = prevState.multitouchAssetConfigurationarray.map((asset) =>
          asset.configID === record.configID
              ? { ...asset, allowFlag: isChecked ? "Yes" : "No" }
              : asset
        );

        
        const updatedOriginalMultiTouchAssets = prevState.originalMultitouchAssetConfigurationarray.map((asset) =>
          asset.configID === record.configID
              ? { ...asset, allowFlag: isChecked ? "Yes" : "No" }
              : asset
      );
  
          return {
             
              multitouchAssetConfigurationarray: updatedMultiTouchAssets, // Update multitouchAssetConfigurationarray-5617
              originalMultitouchAssetConfigurationarray:updatedOriginalMultiTouchAssets
          };
        }
        else{
          const updatedAssets = prevState.permittedAsset.map((asset) =>
            asset.supportDocID === record.supportDocID
                ? { ...asset, allowFlag: isChecked ? "Yes" : "No" }
                : asset
        );

        const updatedOriginalAssets = prevState.originalPermittedAsset.map((asset) =>
            asset.supportDocID === record.supportDocID
                ? { ...asset, allowFlag: isChecked ? "Yes" : "No" }
                : asset
        );

        return {
            permittedAsset: updatedAssets,
            originalPermittedAsset: updatedOriginalAssets, // Persist selection state
        };
        }
    });
};

/**
   * @author : Nilesh Zinzurao-5612
   * @description : function for Check and uncheck all assets
   */
handleSelectAll = (e) => {
  const isChecked = e.target.checked;
  //Rutuja 5617 added below code when multitouch asset config is on
if(this.state.multitouchAssetConfigurationCheck == "Yes"){
  this.setState((prevState) => ({
    multitouchAssetConfigurationarray: prevState.multitouchAssetConfigurationarray.map((asset) => ({
      ...asset,
      allowFlag: isChecked ? "Yes" : "No",
    })),
    originalMultitouchAssetConfigurationarray: prevState.originalMultitouchAssetConfigurationarray.map((asset) => ({
      ...asset,
      allowFlag: isChecked ? "Yes" : "No",
    })),
   
  }));
}
  else{
    this.setState((prevState) => ({
      permittedAsset: prevState.permittedAsset.map((asset) => ({
        ...asset,
        allowFlag: isChecked ? "Yes" : "No",
      })),
      originalPermittedAsset: prevState.originalPermittedAsset.map((asset) => ({
        ...asset,
        allowFlag: isChecked ? "Yes" : "No",
      })),
     
    }));
  }
  
};

  /**
   * @author : Chaitanya Shinde-5566
   * @description : function for apply asset changes
   */
  handleApplyChanges = async () => {
    //Rutuja 5617 when multitouch asset config is yes then assed below code
    const { user } = this.props.auth;
    var userID = user.userID;
    const userName = `${user.firstName} ${user.lastName}`; // Full name
    var updatedAsset;
    var updatedAssets;
    var updatedOriginalAssets;
    if(this.state.multitouchAssetConfigurationCheck == "Yes"){
      var { multitouchAssetConfigurationarray,originalMultitouchAssetConfigurationarray, campID } = this.state;

       updatedOriginalAssets = originalMultitouchAssetConfigurationarray.map((asset) => {
         updatedAsset = multitouchAssetConfigurationarray.find(
            (p) => p.configID === asset.configID
        );
        return updatedAsset ? { ...asset, allowFlag: updatedAsset.allowFlag } : asset;
    });

    
     updatedAssets = updatedOriginalAssets.map((asset) => ({
      ...asset,
      allowFlag: asset.allowFlag === null ? "Yes" : asset.allowFlag,
    }));
    
    //Nilesh-5612- Update state to ensure selections persist across actions
    this.setState({ multitouchAssetConfigurationarray: updatedOriginalAssets, originalMultitouchAssetConfigurationarray: updatedOriginalAssets });
    }
    else{
    var { permittedAsset, originalPermittedAsset, campID } = this.state;
   
      //Nilesh-5612- Update the allowFlag for all assets in the original list
       updatedOriginalAssets = originalPermittedAsset.map((asset) => {
         updatedAsset = permittedAsset.find(
            (p) => p.supportDocID === asset.supportDocID
        );
        return updatedAsset ? { ...asset, allowFlag: updatedAsset.allowFlag } : asset;
    });

    //Nilesh-5612- Set default allowFlag to "Yes" if null
     updatedAssets = updatedOriginalAssets.map((asset) => ({
      ...asset,
      allowFlag: asset.allowFlag === null ? "Yes" : asset.allowFlag,
    }));
    //Nilesh-5612- Update state to ensure selections persist across actions
    this.setState({ permittedAsset: updatedOriginalAssets, originalPermittedAsset: updatedOriginalAssets });
}

    // Check if at least one asset is selected
    const hasSelectedAsset = updatedAssets.some(
      (asset) => asset.allowFlag === "Yes"
    );

    if (!hasSelectedAsset) {
      await Swal.fire({
        type: "warning",
        title: "No Asset Selected!",
        text: "Please select at least one asset to apply.",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return; // Exit if no asset is selected
    }

    // Identify unchecked assets (not allowed)
    const uncheckedAssets = updatedAssets.filter(
      (asset) => asset.allowFlag !== "Yes"
    );

    // Show Swal only if there are unchecked assets
    if (uncheckedAssets.length > 0) {
      const { value: rejectionReason } = await Swal.fire({
        type: "question",
        title: "Reason Required",
        html:
          "<span style='color:red;'><b>*Please provide a reason for not allowing asset</b></span>" +
          "<div><textarea id='rejectionReason' rows='3' cols='40' placeholder='Enter reason here...'></textarea></div>",
        focusConfirm: false,
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonText: "Submit",
        cancelButtonText: "Cancel", //Chaitanya-5566-Changed button color
        customClass: {
          confirmButton: "swal-custom-btn", // Class for confirm button
          cancelButton: "swal-custom-btn" // Same class for cancel button
        },
        preConfirm: () => {
          const reason = document
            .getElementById("rejectionReason")
            .value.trim();
          if (!reason) {
            Swal.showValidationMessage(
              "Reason is required for unchecked asset!"
            );
            return false;
          }
          return reason;
        },
      });

      // If user cancels the Swal, stop the process
      if (!rejectionReason) {
        return;
      }

      // Attach rejection reason to each unchecked asset
      uncheckedAssets.forEach((asset) => {
        asset.rejectionReason = rejectionReason;
        //console.log(`Asset ID: ${asset.supportDocID}, Rejection Reason: ${asset.rejectionReason}`);
      });
    }

    
    //console.log("data ==> " + JSON.stringify(data));
    //RUtuja when multitouchasset config is yes thencalling route updatemultitouchConfigurationAssets
    try {
      if(this.state.multitouchAssetConfigurationCheck == "Yes"){
        const assetsToUpdate = updatedAssets.map((asset) => ({
          configID: asset.configID,
          allowFlag: asset.allowFlag,
          allowedBy: userID, // Assuming you have userID in props
          rejectionReason: asset.rejectionReason || null, // Include rejection reason if present
          firstTouch : asset.firstTouch,
          secondTouch : asset.secondTouch
        }));
     
      let data = {
        assets: assetsToUpdate,
        logDetails: {
          campID,
          actionByID: userID,
          actionByName: userName,
        },
      };

        var response = await fetch(
          "/publisherDashboard/updatemultitouchConfigurationAssets",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          }
        );

      }
      else{
        const assetsToUpdate = updatedAssets.map((asset) => ({
          supportDocID: asset.supportDocID,
          allowFlag: asset.allowFlag,
          allowedBy: userID, // Assuming you have userID in props
          assetName: asset.suppDocName, // Assuming assetName exists
          rejectionReason: asset.rejectionReason || null, // Include rejection reason if present
        }));
     
      let data = {
        assets: assetsToUpdate,
        logDetails: {
          campID,
          actionByID: userID,
          actionByName: userName,
        },
      };
        var response = await fetch(
          "/publisherDashboard/updatePermittedAssets",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          }
        );
      }
      const result = await response.json();

      if (result.success) {
        Swal.fire({
          type: "success",
          title: "Assets updated successfully!",
          confirmButtonText: "OK",
          allowOutsideClick: false,
          preConfirm: () => {
            window.location.reload();
          },
        });
      } else {
        const failedAssets = result.failedAssets || [];
        let message = result.message;

        if (failedAssets.length > 0) {
          message += `\nFailed Asset IDs: ${failedAssets.join(", ")}`;
        }

        Swal.fire({
          type: "error",
          title: "Failed to update assets.",
          html: result.message.replace(
            "Click OK to view the changes.",
            "<br>Click OK to view the changes."
          ),
          confirmButtonText: "OK",
          allowOutsideClick: false,
          preConfirm: () => {
            window.location.reload();
          },
        });
      }
    } catch (error) {
      console.error("Error updating assets:", error);
      Swal.fire({
        type: "error",
        title: "Error",
        text: "An unexpected error occurred while updating assets.",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
    }
    
  };

  /**
   * @author Narendra Phadke
   * @param  Description handle login cred
   * @return Description return
   */
  componentDidMount() {
    let uploadButtonDisabled = "true";
    this.setState({ uploadButtonDisabled: uploadButtonDisabled }); //Aman-4887-(added to set status before call other route it will disable the button)Prod issue-ABM Upgrade-ABM File not uploaded
    if (!this.props.auth.isAuthenticated) {
      this.props.history.push("/userLogin");
    } else {
      var campIDTemp; //sonali-4032--storing campID in temp variable as it is giving error in set state
      if (this.props.location.state !== undefined) {
        const {
          cancelKey,
          campID,
          parentCampID,
          reallocationID,
          leadkey,
          tab,
        } = this.props.location.state;
        campIDTemp = campID; //sonali-4032--storing campID in temp variable as it is giving error in set state

        this.setState({
          cancelKey,
          campID,
          parentCampID,
          reallocationID,
          leadkey,
          tab,
          key3: leadkey,
        });
      } else if (sessionStorage.getItem("campID") !== undefined) {
        //sonali-4032--addin session variables

        var campID = sessionStorage.getItem("campID");
        var parentCampID = sessionStorage.getItem("parentCampID");
        var reallocationID = sessionStorage.getItem("reallocationID");
        campIDTemp = campID;
        this.setState({ campID, parentCampID, reallocationID });
      } else {
        if (sessionStorage.getItem("parentCampID") === undefined) {
          sessionStorage.clear();
        }
      }

      campID = campIDTemp;
      var data = {
        campID: campID,
      };

      fetch("/publisherDashboard/permittedAssetsData", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
        //body: JSON.stringify(data),//sonali-3968-removing pID
      })
        .then((res) => res.json())
        .then((permittedAsset) => {
          this.setState({
            permittedAsset: permittedAsset.data,
            originalPermittedAsset: permittedAsset.data,
             assetIdCheck: permittedAsset.assetIdCheck, // Anshul-5685: fetching asset id check
          });

        //console.log("multitouchAssetConfiguration ->"+JSON.stringify(permittedAsset.multitouchAssetConfiguration))
        //console.log("multitouchAssetConfigurationarray 1 ->"+JSON.stringify(permittedAsset.multitouchAssetConfigurationarray))
        //Chaitanya-5617-Set values of multitouchAssetConfigurationCheck and multitouchAssetConfigurationarray
        if (permittedAsset.multitouchAssetConfiguration == "Yes") {
          // If multitouchAssetConfigurationCheck is present in the campaignBriefDetails
          this.setState({
            multitouchAssetConfigurationCheck: permittedAsset.multitouchAssetConfiguration,
            multitouchAssetConfigurationarray: permittedAsset.multitouchAssetConfigurationarray.map((item, index) => ({
                key: item.configID, // Use configID as a unique key
                configID: item.configID, // Store configID for future operations
                firstTouch: item.firstTouch,
                secondTouch: item.secondTouch,
                allowFlag : item.allowFlag, //Rutuja 5617
                
            })),
            originalMultitouchAssetConfigurationarray: permittedAsset.multitouchAssetConfigurationarray,
        });

        //console.log("multitouchAssetConfigurationarray 2 ->"+JSON.stringify(this.state.multitouchAssetConfigurationarray))
        } else {
        }
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  }

  render() {
    //Priyanka-5769-added condition of assetID check to display title accordingly
    const assetsData = [
      {
        title: this.state.assetIdCheck === "No" ? "DI Asset ID" : "Asset ID",
        dataIndex: this.state.assetIdCheck === "No" ? "supportDocID" : "supportDocID",
        key: this.state.assetIdCheck === "No" ? "supportDocID" : "supportDocID",
        width: "15%",
        align: "center",
        onHeaderCell: () => ({
          style: { fontSize: "17px", textAlign: "center" },
        }),
        render: (text, record) => (
          this.state.assetIdCheck === "No" ? (
            <Tooltip placement="top" title="DI AssetID" cursor="pointer">
              <div>
                <span style={{ fontSize: "15px" }}>
                  {record.supportDocID}
                </span>
              </div>
            </Tooltip>
          ) : (
            <div>
              <span style={{ fontSize: "15px" }}>
                {record.keyword}
              </span>
            </div>
          )
        ),
      },
      {
        title: "Asset Name",
        dataIndex: "suppDocName",
        key: "suppDocName",
        align: "center",
        width: "70%",
        onHeaderCell: () => ({
          style: { fontSize: "17px", textAlign: "center" }, // Adjust font size here
        }),
        render: (text, record) => (
          <div class="dotUploadSuppression" title={record.suppDocName}>
            {" "}
            <span
              style={{
                fontSize: "15px",
                whiteSpace: "nowrap", // Prevents breaking into multiple lines
                overflow: "hidden", // Hides overflow text
                textOverflow: "ellipsis", // Shows '...' for overflowed text
                maxWidth: "150px", // Set width limit to trigger ellipsis
              }}
            >
              {record.suppDocName}
            </span>
          </div>
        ),
      },
      {
        title:(
          //Nilesh-5612- Add selct all checkbox below
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
            <Tooltip
              title={
                this.state.permittedAsset.length > 0 &&
                this.state.permittedAsset.every((asset) => asset.allowFlag === "Yes" || asset.allowFlag === null)
                  ? "Unselect All"
                  : "Select All"
              }
            >
              <input
                type="checkbox"
                checked={
                  this.state.permittedAsset.length > 0 &&
                  this.state.permittedAsset.every((asset) => (asset.allowFlag === "Yes" || asset.allowFlag === null))
                }
                onChange={this.handleSelectAll}
                style={{ width: "20px", height: "20px", cursor: "pointer", accentColor: "#0A61AD" }}
              />
            </Tooltip>
          </div>
        ),
        dataIndex: "startDate",
        key: "startDate",
        align: "center",
        width: "15%",
        onHeaderCell: () => ({
          style: { fontSize: "17px", textAlign: "center" }, // Adjust font size here
        }),
        render: (text, record) => (
          <div>
            <input
              type="checkbox"
              checked={record.allowFlag === null || record.allowFlag === "Yes"} // Checkbox checked if allowFlag is null or "Yes"
              style={{
                width: "20px",
                height: "20px",
                cursor: "pointer",
                accentColor: "#0A61AD",
              }} // Increases size
              onChange={(e) => this.handleCheckboxChange(e, record)}
            />
          </div>
        ),
      },
    ];
    //console.log("Permitted Asset:", this.state.permittedAsset);
    //console.log("MultiTouch Asset:", this.state.multitouchAssetConfigurationarray);

    //Chaitanya-5617-added columns for asset Columns
    const assetColumns = [
      {
        title: "1st Touch Asset",
        dataIndex: "firstTouch",
        key: "firstTouch",
        width: "50%",
        onHeaderCell: () => ({
          style: { fontSize: "17px", textAlign: "center" }, // Adjust font size here
        }),
        render: (text) => 
        <span 
        title={text}
        style={{ 
          display: "inline-block",
          fontSize: "15px",
          whiteSpace: "nowrap", // Prevents breaking into multiple lines
          overflow: "hidden", // Hides overflow text
          textOverflow: "ellipsis", // Shows '...' for overflowed text
          maxWidth: "100%", // Set width limit to trigger ellipsis
        }}>{text}</span>,
      },
      {
        title: "2nd Touch Asset",
        dataIndex: "secondTouch",
        key: "secondTouch",
        width: "50%",
        onHeaderCell: () => ({
          style: { fontSize: "17px", textAlign: "center" }, // Adjust font size here
        }),
        render: (text) => 
        <span 
        title={text}
        style={{ 
          display: "inline-block",
          fontSize: "15px" ,
          whiteSpace: "nowrap", // Prevents breaking into multiple lines
          overflow: "hidden", // Hides overflow text
          textOverflow: "ellipsis", // Shows '...' for overflowed text
          maxWidth: "100%", // Set width limit to trigger ellipsis
        }}>{text}</span>,
      },
      {
        title:(
          // Add selct all checkbox below
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
            <Tooltip
              title={
                this.state.multitouchAssetConfigurationarray.length > 0 &&
                this.state.multitouchAssetConfigurationarray.every((asset) => asset.allowFlag === "Yes" || asset.allowFlag === null)
                  ? "Unselect All"
                  : "Select All"
              }
            >
              <input
                type="checkbox"
                checked={
                  this.state.multitouchAssetConfigurationarray.length > 0 &&
                  this.state.multitouchAssetConfigurationarray.every((asset) => (asset.allowFlag === "Yes" || asset.allowFlag === null))
                }
                onChange={this.handleSelectAll}
                style={{ width: "20px", height: "20px", cursor: "pointer", accentColor: "#0A61AD" }}
              />
            </Tooltip>
          </div>
        ),
        dataIndex: "startDate",
        key: "startDate",
        align: "center",
        width: "15%",
        onHeaderCell: () => ({
          style: { fontSize: "17px", textAlign: "center" }, // Adjust font size here
        }),
        render: (text, record) => (
          <div>
            <input
              type="checkbox"
              checked={record.allowFlag === null || record.allowFlag === "Yes"} // Checkbox checked if allowFlag is null or "Yes"
              style={{
                width: "20px",
                height: "20px",
                cursor: "pointer",
                accentColor: "#0A61AD",
              }} // Increases size
              onChange={(e) => this.handleCheckboxChange(e, record)}
            />
          </div>
        ),
      },
    ];

    return (
      <div>
        <PublisherNavigation />

        <div
          style={{ paddingTop: "7%", paddingBottom: "20px" }}
          class="container-fluid responsive-padding"
        >
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 text-center">
              <a href="#/" onClick={this.backButtonFunction.bind(this)}>
                <FaArrowAltCircleLeft
                  size={32}
                  style={{
                    float: "left",
                    marginRight: "20px",
                    marginBottom: "5px",
                    color: "#193D8F",
                  }}
                  title="Back to Campaign Progress"
                />
              </a>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 text-center">
              <label
                id="campallocation"
                style={{ fontWeight: "bold", color: "#193D8F" }}
              >
                <span style={{ fontSize: "30px", display: "block" }}>
                  {/* Chaitanya-5602-Change Page title */}
                  {this.state.campID} : Mandatory Assets
                </span>
              </label>
            </div>

            {/* <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 text-center">
               <button
                className="btn add-button"
                onClick={this.refreshPage}
                style={{
                  float: "right",
                  backgroundColor: "#056eb8",
                  color: "#fff",
                  width: "min-content",
                  fontSize: "14px",
                  borderColor: "#056eb8",
                }}
              >
                {" "}
                Refresh
              </button> 
            </div> */}
          </div>

          <div class="row">
            <div className="col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1"></div>
            <div className="col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10">
              <div className="card card-signin my-1">
                <div className="card-body">
                  <div
                    className="row"
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      padding: "0% 3%",
                    }}
                  >
                    {/* NOTE Section */}
                    <div style={{ flex: 1 }}>
                      <dt style={{ fontWeight: "bold", color: "#F28C0F" }}>
                        NOTE :
                      </dt>
                      <ol
                        style={{
                          fontSize: "16px",
                          //  paddingLeft: "20px"
                        }}
                      >
                        {/* Chaitanya-5602-Change 1st tooltip */}
                        <li>
                        Lead must be uploaded for all the assets with selected checkboxes.
                        </li>
                        {/* Chaitanya-5614-Change 2nd tooltip */}
                        <li>
                          The Mandatory assets settings will remain active for
                          12 hours only.
                        </li>
                      </ol>
                    </div>

                    {/* Search Bar Section */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <input
                        id="search-bar2"
                        type="text"
                        style={{
                          backgroundImage: "url(Group_294.png)",
                          backgroundPosition: "15px center",
                          backgroundSize: "15px 15px",
                          backgroundRepeat: "no-repeat",
                          height: "35px",
                          fontSize: "14px",
                          border: "1px solid #ddd",
                          padding: "0 20px 0 40px",
                          borderRadius: "25px",
                          backgroundColor: "rgb(221, 221, 221)",
                          width: "200px", // Adjust width as needed
                        }}
                        onChange={this.handleChangeSearch}
                        placeholder="Search..."
                        title="Search"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div class="table-responsive">
                      {this.state.multitouchAssetConfigurationCheck === "Yes" ? (
                        <div class="col-sm-12">
                          {/* Chaitanya-5617  added table for multitouch asset config*/}
                          <Table
                            {...this.state.tableState}
                            columns={assetColumns}
                            dataSource={this.state.multitouchAssetConfigurationarray}
                            pagination={false}
                            bordered
                            id="myTable"
                            showHeader={true}
                            // size="small"
                            // class="ant-table-thead"
                            scroll={{
                              y: 350, // Sets vertical scroll height
                              x: 600, // Ensures horizontal scroll when needed
                            }}
                            className={tableCSS}
                          >
                          </Table>
                        </div>
                        ) : (
                        <div class="col-sm-12">
                          {/* Chaitanya-5566-Table for permitted Assets data*/}
                          <Table
                            {...this.state.tableState}
                            id="myTable"
                            bordered
                            dataSource={this.state.permittedAsset}
                            loading={this.state.loading2}
                            //onChange={onChange}
                            columns={assetsData}
                            className={tableCSS}
                            scroll={{
                              y: 350, // Sets vertical scroll height
                              x: 600, // Ensures horizontal scroll when needed
                            }}
                            pagination={false} // Disables pagination
                          ></Table>
                        </div>
                        )}
                        <table class="table table-bordered table-striped"></table>
                      </div>
                      {this.state.permittedAsset.length > 0 ? (
                        <div
                          style={{
                            textAlign: "right",
                            paddingRight: "1%",
                            marginBottom: "-3%",
                          }}
                        >
                          {" "}
                          <button
                            class="btn add-button"
                            type="HTMLsubmit"
                            onClick={this.handleApplyChanges}
                          >
                            Apply
                          </button>
                        </div>
                      ) : (
                        <div
                          style={{
                            textAlign: "right",
                            paddingRight: "1%",
                            marginBottom: "-3%",
                          }}
                        >
                          {" "}
                          <button
                            class="btn add-button"
                            type="HTMLsubmit"
                            disabled
                          >
                            Apply
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1"></div>
          </div>
        </div>
        <Footer />
      </div>
    );
  } //end of render
} // end of constructor

/**
 * @author Narendra Phadke
 * @param  Description handle the login authentication
 * @return Description return All details of authentication
 */

PermittedAssets.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});
export default connect(mapStateToProps, { logoutUser })(
  withRouter(PermittedAssets)
);

//      backgroundColor: '#000080 !important;
    //  color: '#f3f6fa !important;